import { ref } from 'vue'

export const relatedGroupBus = ref<number[]>([])
